import React from "react";
import { Link } from "react-router-dom";
import { t } from "../../i18n";
import { FaPhone, FaCalendarCheck } from "react-icons/fa";
import gaHero from "../../assets/images/heroes/ga-hero-main.webp";
import ncHero from "../../assets/images/heroes/nc-hero-main.webp";
import "./Hero.css";

// Primary: use downloaded public/ hero images
const BRAND_HEROES = {
  gso: "/assets/images/heroes/car-crash-hero.webp",
  "apex-nc": "/assets/images/heroes/apex-hero.webp",
  "apex-tn": "/assets/images/heroes/apex-hero.webp",
};

// Fallback: bundled src assets (always available)
const BRAND_HEROES_FALLBACK = {
  gso: gaHero,
  "apex-nc": ncHero,
  "apex-tn": ncHero,
};

export default function Hero({ service, location, client, locale = "en", h1Override }) {
  const brandKey = client.brandKey || 'gso';
  const heroImg = BRAND_HEROES[brandKey] || gaHero;
  const fallbackImg = BRAND_HEROES_FALLBACK[brandKey] || gaHero;

  return (
    <section
      className="hero"
      style={{
        backgroundImage: `linear-gradient(var(--glass-hero-overlay, rgba(26,54,93,0.75)), var(--glass-hero-overlay, rgba(26,54,93,0.75))), url(${heroImg}), url(${fallbackImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            {h1Override || `${service.display} in ${location.city}, ${location.state}`}
          </h1>
          <p className="hero-subtitle">
            {t("hero.description", locale)}
          </p>
          <div className="hero-actions">
            <Link to="/request-appt" className="hero-btn-primary">
              <FaCalendarCheck /> {t("cta.schedule", locale)}
            </Link>
            <a href={`tel:${client.phone}`} className="hero-btn-secondary">
              <FaPhone /> {t("cta.call", locale)}: {client.phone}
            </a>
          </div>
          <div className="hero-keywords">
            {service.keywords?.slice(0, 4).map((kw, i) => (
              <span key={i} className="hero-keyword-tag">{kw}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
